<template>
  <div class="features container">
    <div class="item item1 bg">
      <div class="wrap">
        <div class="img-box">
          <img class="w-240" src="@/assets/about/js12.png" alt />
        </div>
        <div class="mt-32 mb-24 img-box">
          <img class="w-320" src="@/assets/about/js1.png" alt />
        </div>
        <div class="info">
            快递鸟企业寄件系统，是快递鸟为中小企业提供的在线寄快递产品，为集团企业和直接发货用户解决集中的对账结算以及内部的快递集中管理问题，帮助企业实现集中发货管理、使用透明、统一管理的业务需求；
        </div>
      </div>
      <!-- <div class="bg">
        <img class="w-100p" src="@/assets/about/js2.png" alt />
      </div> -->
    </div>
    <div class="item item2">
        <ul>
            <li>
                <div class="title">一、为公司创建新的账号</div>
                <div><img class="w-354" src="@/assets/about/1.gif" alt="" @click="viewImg(0)"></div>
                <div class="sub-title">由公司行政主管，使用手机号、公司登录账号以及登录密码即可完成创建。</div>
            </li>
            <li>
                <div class="title">二、寄件前的准备工作</div>
                <div><img class="w-354" src="@/assets/about/2.gif" alt="" @click="viewImg(1)"></div>
                <div class="sub-title">
                    1、设置常用快递公司；<br>
                    2、单独配置每家快递公司的结算方式；<br>
                    3、单独向财务请款后预充一定运费金额；<br>
                    4、设置部门与员工子账号；<br>
                    5、将员工子账号通过邮箱或微信发给员工。
                </div>
            </li>
            <li>
                <div class="title">三、员工如何寄快递</div>
                <div><img class="w-354" src="@/assets/about/3.gif" alt="" @click="viewImg(2)"></div>
                <div class="sub-title">
                   1、登录管理员或员工账号；<br>
                    2、点击“我要寄件”填完必填信息即可完成快递；<br>
                    3、支持“因公寄件”、“个人寄件”；<br>
                    4、管理员账号也可以寄件。
                </div>
            </li>
            <li>
                <div class="title">四、寄件统计与对账</div>
                <div><img class="w-354" src="@/assets/about/4.gif" alt="" @click="viewImg(3)"></div>
                <div class="sub-title">
                   1、按天统计寄件量和运费情况；<br>
                    2、所有通过线上支付的订单形成月度对账单。
                </div>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
// import { ImagePreview } from 'vant'
export default {
  props: {},
  components: {
  },
  data() {
    return {
      list: [
        require('@/assets/about/1.gif'),
        require('@/assets/about/2.gif'),
        require('@/assets/about/3.gif'),
        require('@/assets/about/4.gif')
      ],
      index: 0
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    copy() {
      this.$tool.copy(this.copyMsg)
    },
    goHome() {
      this.$router.push({
        name: 'home'
      })
    },
    viewImg(i) {
      // this.index = i
      // ImagePreview({
      //   images: this.list,
      //   startPosition: i,
      //   loop: false,
      //   onClose() {

      //   }
      // })
    }
  }
}
</script>

<style scoped lang="scss">

.features {
  padding: 0;
}
.item {
   background-image: url('~@/assets/about/js2.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;;
  line-height:24px;
  padding: 40px 30px;
  .title {
    color: #1890ffff;
    font-size: 22px;
    line-height: 30px;
    margin-bottom:20px;
  }
  .btn {
    margin-bottom: 15px;
  }
}
.item1 {
  text-align:center;
  height: 512px;
  position: relative;
  .wrap {
    position: relative;
    z-index: 2;
    
  }
  .bg {
   
  }
  .info{
      color:#fff;
      font-weight:500;
      padding-top:10px;
      line-height:30px;
      text-align:left;
  }
}
.ul{
  list-style: none;
}
.item2{
    background:#fff;
    ul{
      list-style: none;
      margin: 0;
        li{
            margin-bottom:40px;
            .sub-title{
                color:#666666FF;
                font-size:13px;
                margin-top:20px;
            }
        }
    }
}
</style>
